module.exports = function getResource(label, vars = []) {
    const resources = {
        add: 'Add',
        buyOnlinePickUpTitle: `Buy Online & Pick Up (${vars[0]}) `,
        storeDetails: 'Store Details',
        bopisInfoTitle: 'Buy Online & Pick Up in Store',
        certonaInfoTitle: `Also Available for Pickup at ${vars[0]}`
    };

    return resources[label];
};
